import { BaseAvatarCell } from "./BaseAvatarCell";
import type { Contact } from "@/types/contact";

interface ContactAvatarCellProps {
  contact: Contact;
  onClick?: () => void;
  hideDetailsLabel?: boolean;
  nonClickable?: boolean;
  showEmail?: boolean;
}

/**
 * Avatar cell component for contacts table that handles avatarUrl field
 * Resolves image IDs to URLs using the image service when needed
 * Supports both UUID image IDs and direct URLs (http/https/data/blob/relative paths)
 * Can be used in both clickable (table) and non-clickable (selector) contexts
 */
export function ContactAvatarCell({ 
  contact, 
  onClick, 
  hideDetailsLabel = false,
  nonClickable = false,
  showEmail = false
}: ContactAvatarCellProps) {
  return (
    <BaseAvatarCell 
      entity={contact} 
      onClick={onClick}
      hideDetailsLabel={hideDetailsLabel}
      nonClickable={nonClickable}
      subtitle={showEmail ? contact.emailMain : undefined}
      subtitleField={showEmail && !contact.emailMain ? 'emailMain' as keyof Contact : undefined}
    />
  );
}